module.exports = ".errorMessage {\n  color: #a94442;\n  margin-top: 1rem; }\n"